import $ from 'jquery';
import { createPopper } from '@popperjs/core';

export default function(headerMainNav: HTMLUListElement): void {
    const jqHeaderMainNav = $(headerMainNav);
    const jqDropdownLIs = $(headerMainNav).find('.js-dropdown-li');

    jqDropdownLIs.each((index, dropdownLI) => {
            const jqDropdownLI = $(dropdownLI);
            const jqDropdownLink = jqDropdownLI.find('.js-dropdown-nav-link');
            const jqDropdownMenu = jqDropdownLI.find('.js-dropdown-menu');

            if(!jqDropdownLink.length || !jqDropdownMenu.length) {
                return;
            }

            // Set the max height of the product categories mega menu dropdown
            function setMaxHeight() {
                setTimeout(function() {
                    const jqDropdownContainer = jqDropdownMenu.children('ul');
                    if (jqDropdownContainer.hasClass('mega-menu__product-categories')) {
                        var maxHeight = 175;
                        jqDropdownContainer.find('li').each(function() {
                            if (this.offsetHeight > maxHeight) {
                                maxHeight = this.offsetHeight;
                            }
                        });
                        jqDropdownContainer.css("max-height", (maxHeight + 90) + 'px')
                    }
                    jqDropdownLink.off('click', setMaxHeight);
                    }, 10);
            }

            jqDropdownLink.on('click', setMaxHeight);
        }
    );

    //
    // Basket summary tooltips for narrow desktop views
    //
    const tooltips = [
        [
            document.querySelector('.header__basket-summary_free-delivery-icon') as HTMLDivElement | null,
            document.getElementById('js-header__basket-summary_free-delivery') as HTMLSpanElement | null,
        ],
        [
            document.querySelector('.header__basket-summary_warning-icon') as HTMLDivElement | null,
            document.getElementById('js-header__basket-summary_warning') as HTMLSpanElement | null,
        ],
    ];

    tooltips.forEach(([ content, tooltip ]) => {
        if (content === null || tooltip === null) {
            return;
        }

        const popper = createPopper(content, tooltip, {
            placement: 'top',
            modifiers: [
                { name: 'offset', options: { offset: [ 0, 8 ] } },
            ],
        });

        [ 'mouseenter', 'focus' ].forEach(event => {
            content.addEventListener(event, () => {
                tooltip.setAttribute('data-show', '');
                popper.update();
            });
        });

        [ 'mouseleave', 'blur' ].forEach(event => {
            content.addEventListener(event, () => {
                tooltip.removeAttribute('data-show');
            });
        });
    });
}
